import React from 'react';

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: '#00796b',
            padding: '30px 20px',
            color: 'white',
            textAlign: 'center',
            borderTop: '5px solid #40E0D0',
        }}>
            <p style={{ fontSize: '1rem', margin: '5px 0' }}>
                📲 <strong>WhatsApp:</strong> <a href="https://wa.me/916354311491" style={{ color: '#FFEB3B', textDecoration: 'none' }}>+91 6354311491</a>
            </p>
            <p style={{ fontSize: '1rem', margin: '5px 0' }}>
                💌 <strong>Email:</strong> <a href="mailto:service@indienbuddy.com" style={{ color: '#FFEB3B', textDecoration: 'none' }}>service@indienbuddy.com</a>
            </p>
            <p style={{ fontSize: '1rem', margin: '5px 0' }}>
                📸 <strong>Instagram:</strong> <a href="https://www.instagram.com/indienbuddy" target="_blank" rel="noopener noreferrer" style={{ color: '#FFEB3B', textDecoration: 'none' }}>@indienbuddy</a>
            </p>
            <p style={{
                marginTop: '20px',
                fontSize: '0.9rem',
                fontStyle: 'italic',
                color: '#B2DFDB',
            }}>
                © 2025 Indien Buddy. All rights reserved.
            </p>
        </footer>
    );
};

export default Footer;
